var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_95_2502)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_2502)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 52,
    rx: 25.5,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.07752,
    height: 26.5936,
    rx: 1.53876,
    transform: "matrix(-0.971842 -0.235635 0.154771 -0.98795 16.7236 39.4993)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.07752,
    height: 26.5936,
    rx: 1.53876,
    transform: "matrix(-0.971842 -0.235635 0.154771 -0.98795 25.8301 39.4993)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.07752,
    height: 26.5936,
    rx: 1.53876,
    transform: "matrix(-0.971842 -0.235635 0.154771 -0.98795 34.9365 39.4993)",
    fill: "#797979"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 51.5,
    height: 52.5,
    rx: 25.75,
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_95_2502",
    x: 0,
    y: 0,
    width: 63,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_95_2502"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_2502"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_2502"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 52,
    rx: 25.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logoFooter.4c632b49abef98af890e1b6152e906b7.svg";
export { ForwardRef as ReactComponent };